import { CustomerProfileTypeOfBusinessEnum } from "../../../types/drayage";

export const CustomerProfileTypeOfBusinessOptions = [
  {
    label: "Broker",
    value: CustomerProfileTypeOfBusinessEnum.Broker,
  },
  {
    label: "Shipper",
    value: CustomerProfileTypeOfBusinessEnum.Shipper,
  },
  {
    label: "Freight Forwarder",
    value: CustomerProfileTypeOfBusinessEnum.FreightForwarder,
  },
];
